import React from 'react';
import {Box, Container, Grid, Paper, Typography} from '@mui/material';

const WhatAwaitsSection: React.FC = () => {
    const items = [
        {
            title: "Поспілкуєтесь з тими, хто вже обрав свій шлях:",
            description: "наставництво від студентів-амбасадорів, знайомство з випускниками Могилянки та неформальні зустрічі зі студентами та викладачами"
        },
        {
            title: "Розберетеся зі спеціальностями на практиці:",
            description: "заняття та інтерактивні воркшопи у вибраній сфері, доповнені виїзним днем до партнерської компанії, щоб відчути справжнє професійне середовище та глибше зануритися в напрямок"
        },
        {
            title: "Отримаєте корисні поради для підготовки до НМТ:",
            description: "як ефективно готуватися до іспитів та писати мотиваційні листи, щоб вони дійсно працювали на вас"
        },
        {
            title: "Відчуєте себе частиною могилянської спільноти:",
            description: "екскурсії кампусом, інтерактивні лекції, дебати, де ви зможете вільно висловлювати свої думки та дискутувати"
        }
    ];

    return (
        <Container id={'what-awaits'} maxWidth="lg" sx={{ pb: { xs: 6, md: 8 } }}>
            <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: { xs: '2.5rem', md: '4rem' },
                        fontWeight: 700,
                        fontFamily: 'Kyiv Type Serif',
                        mb: 4
                    }}
                >
                    Що чекає на вас
                </Typography>
            </Box>

            <Grid container rowSpacing={10} columnSpacing={2}>
                {items.map((item, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Paper
                            sx={{
                                bgcolor: '#B09EBA',
                                p: { xs: 3, md: 4 },
                                pb: { xs: 1, md: 2 },
                                height: '100%',
                                borderRadius: '8px',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 2,
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '1.1rem', md: '1.25rem' },
                                    color: '#FFFFFF',
                                }}
                            >
                                {item.title}
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#FFFFFF',
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: { xs: '1rem', md: '1.1rem' },
                                }}
                            >
                                {item.description}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default WhatAwaitsSection;

